import { Injectable } from '@angular/core';
import { CheckYourEmail } from '@com-delta-idp/mnx-login-ui';
import { LoginModalContent, ResetPasswordFormValues } from '../../models/aem';

@Injectable({
  providedIn: 'root'
})
export class CheckEmailAdapterService {
  getCheckEmailScreenContent(
    loginModalContent: LoginModalContent,
    isNewResetPasswordFlow = false,
    newForgotLoginFlow = false
  ): CheckYourEmail {
    let checkYourEmail = loginModalContent.checkYourEmail;
    const { pageHeader } = loginModalContent;
    if (isNewResetPasswordFlow) {
      if (!newForgotLoginFlow) {
        checkYourEmail = loginModalContent.newResetPasswordCheckYourEmail;
      } else {
        checkYourEmail = loginModalContent.newForgotLoginCheckYourEmail;
      }
    }

    const pageHeaderObj = {
      logoUrl: pageHeader.logoUrl,
      altText: pageHeader.altText
    };

    return {
      ...pageHeaderObj,
      ...{
        ...checkYourEmail,
        checkEmailMessage: checkYourEmail.checkEmailMessage_Login,
        hasError: false,
        errorMessage: '',
        disabledActionButton: false,
        skipSqaContent: false
      }
    };
  }

  formatCheckEmailMessage(
    checkYourEmail: CheckYourEmail,
    resetPasswordFormValues: ResetPasswordFormValues
  ): CheckYourEmail {
    const checkEmailMessage = checkYourEmail?.checkEmailMessage;
    const formattedCheckEmailMessage =
      checkEmailMessage &&
      checkEmailMessage
        .replace('$$skymilesNumber$$', resetPasswordFormValues?.skymilesNumber)
        .replace('$$firstName$$', resetPasswordFormValues?.firstName)
        .replace('$$lastName$$', resetPasswordFormValues?.lastName);
    checkYourEmail.skipSqaContent = !!resetPasswordFormValues.skipSqaContent;
    checkYourEmail.checkEmailMessage = formattedCheckEmailMessage;
    return checkYourEmail;
  }
}
